import { callAPI } from 'Action';
import { EU_FILE_UPLOAD, EU_FILE_UPLOAD_SUCESSFULLY } from './types';
import { appConstantUrl } from 'appConstant';

export const euFileUpload = (value: any, supplierId: string) => async (dispatch: any) => {
  let url = appConstantUrl.euFileUpload;
  let reqObj = value;

  const options = {
    url,
    actionType: EU_FILE_UPLOAD,
    method: 'POST',
    reqObj,
    dispatch,
    headers: {
      supplierId: supplierId,
    },
  };
  let data = await callAPI(options);
  if (data) {
    dispatch({
      type: EU_FILE_UPLOAD_SUCESSFULLY,
      payload: data,
    });
  }
  return data;
};
export const resetFileUpload = () => (dispatch: any) => {
  dispatch({
    type: 'RESET_ERROR',
  });
  dispatch({ type: EU_FILE_UPLOAD, payload: null });
  dispatch({ type: EU_FILE_UPLOAD_SUCESSFULLY, payload: null });
};
